import { financialAr } from './mediaInitiative/financialAr';
import { financialEn } from './mediaInitiative/financialEn';
import { frameworkAr } from './mediaInitiative/frameworkAr';
import { frameworkEn } from './mediaInitiative/frameworkEn';
import { operationalRoleAr } from './mediaInitiative/operationalRoleAr';
import { operationalRoleEn } from './mediaInitiative/operationalRoleEn';
import { partnershipAr } from './mediaInitiative/partnershipAr';
import { partnershipEn } from './mediaInitiative/partnershipEn';
import { programFormatAr } from './mediaInitiative/programFormatAr';
import { programFormatEn } from './mediaInitiative/programFormatEn';
import { visionAr } from './mediaInitiative/visionAr';
import { visionEn } from './mediaInitiative/visionEn';

/**
 * HOLOL Global Economic Media Initiative page.
 * Each section is sourced from one PDF (EN and AR versions) in src/newPageData or public/pdfs.
 * Block shapes are documented in pages/MediaInitiativePage.js.
 */
export const mediaInitiativePageEn = {
  hero: {
    lines: [
      { primary: 'HOLOL GLOBAL REAL ESTATE CLUB' },
      { primary: 'GLOBAL ECONOMIC MEDIA INITIATIVE' },
    ],
    tagline: 'STRATEGIC VISION & GLOBAL PARTNERSHIPS',
    lead: 'From a TV program to a global media ecosystem driving economies & opening markets',
    founder: 'Dr. Adham Elsharkawy — Founder of HOLOL Real Estate Club',
  },
  stats: [
    { value: '100', label: 'Programs within 5 years' },
    { value: '52', label: 'Episodes per year' },
    { value: '$6.4M', label: 'Target annual media revenue' },
    { value: '90', label: 'Days to activate & launch' },
  ],
  sectionNavTitle: 'Explore the initiative',
  stepLabel: 'Part',
  moreButton: 'Learn more',
  sections: [frameworkEn, visionEn, partnershipEn, operationalRoleEn, financialEn, programFormatEn],
  closing: {
    eyebrow: 'HOLOL Global Economic Media Initiative',
    lines: [
      'Media that opens markets.',
      'Media that connects economies.',
      'Media that creates opportunities.',
    ],
    name: 'Dr. Adham Elsharkawy',
    role: 'Founder & Chairman — HOLOL Global Real Estate Club',
    whatsappLabel: 'WhatsApp',
    emailLabel: 'Email',
  },
};

export const mediaInitiativePageAr = {
  hero: {
    lines: [
      { primary: 'نادي حلول العقاري العالمي', secondary: 'HOLOL GLOBAL REAL ESTATE CLUB', separator: '|' },
      {
        primary: 'مبادرة إعلامية اقتصادية عالمية',
        secondary: 'GLOBAL ECONOMIC MEDIA INITIATIVE',
        separator: '-',
      },
    ],
    tagline: 'الرؤية الاستراتيجية والشراكات العالمية',
    taglineSecondary: 'STRATEGIC VISION & GLOBAL PARTNERSHIPS',
    lead: 'من برنامج تلفزيوني إلى منظومة إعلامية اقتصادية عالمية تفتح الأسواق',
    founder: 'دكتور / أدهم الشرقاوي — مؤسس نادي حلول العقاري',
  },
  stats: [
    { value: '100', label: 'برنامج خلال 5 سنوات' },
    { value: '52', label: 'حلقة سنويًا' },
    { value: '$6.4M', label: 'إيرادات إعلامية مستهدفة سنويًا' },
    { value: '90', label: 'يومًا للتفعيل والإطلاق' },
  ],
  sectionNavTitle: 'محاور المبادرة',
  stepLabel: 'المحور',
  moreButton: 'لمعرفة المزيد',
  sections: [frameworkAr, visionAr, partnershipAr, operationalRoleAr, financialAr, programFormatAr],
  closing: {
    eyebrow: 'المبادرة الإعلامية الاقتصادية العالمية لحلول',
    lines: [
      'إعلام يفتح الأسواق.',
      'إعلام يربط الاقتصادات.',
      'إعلام يصنع الفرص.',
    ],
    name: 'الدكتور أدهم الشرقاوي',
    role: 'مؤسس ورئيس نادي حلول العقاري العالمي',
    whatsappLabel: 'واتساب',
    emailLabel: 'البريد الإلكتروني',
  },
};
